var render = function render(){var _vm=this,_c=_vm._self._c;return _c('utility-detail-link',{ref:"utilityDetailLink",attrs:{"detailLayout":_vm.detailLayout,"utilityData":_vm.utilityData,"utilKey":_vm.utilKey,"userKey":_vm.userKey,"utilTopCategory":_vm.utilityTopCategoryList,"utilBottomCategory":_vm.utilityBottomCategoryList,"defaultApiParamsSet":_vm.defaultApiParamsSet}})
}
var staticRenderFns = []

export { render, staticRenderFns }